import { InfoOutlined } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { RenderMarkdown } from './elements/markdown-rendering/RenderMarkdown'

interface Props {
  tooltip?: string
}

const QuestionTooltip = ({ tooltip }: Props) => {
  const trimmedTooltip = tooltip?.trim()
  if (!trimmedTooltip) {
    return null
  }

  return (
    <Tooltip
      title={
        <RenderMarkdown
          markdownString={trimmedTooltip}
          typographyProps={{
            variant: 'small-regular',
            mb: 1,
            sx: {
              '& p': {
                marginTop: 0,
              },
              '& p:last-of-type': {
                marginBottom: 0,
              },
            },
          }}
        />
      }
      placement="right"
    >
      <InfoOutlined sx={{ color: 'fg.subtle', fontSize: 16, mt: '2px !important', ml: 2 }} />
    </Tooltip>
  )
}

export { QuestionTooltip }
